var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalianIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4167 5.66667H27.2736C26.6149 2.43808 23.7546 0 20.3334 0H7.58336C3.67761 0 0.500025 3.17758 0.500025 7.08333V25.2946C0.423525 27.6505 3.31069 29.1975 5.23027 27.8262L9.43353 25.024C10.411 27.7681 13.0078 29.75 16.0834 29.75H24.1541L29.7684 33.4928C31.6894 34.8628 34.5751 33.3172 34.5 30.9613V12.75C34.5 8.84425 31.3224 5.66667 27.4167 5.66667ZM3.65777 25.4688C3.58836 25.5822 3.27811 25.415 3.33336 25.2946V7.08333C3.33336 4.74017 5.24019 2.83333 7.58336 2.83333H20.3334C22.6765 2.83333 24.5834 4.74017 24.5834 7.08333V17C24.5834 19.3432 22.6765 21.25 20.3334 21.25H10.4167C10.1362 21.2486 9.87411 21.3605 9.63044 21.488L3.65777 25.4688ZM31.6667 30.9613C31.7219 31.0817 31.4103 31.2474 31.3409 31.1355L25.3696 27.1547C25.1373 27.0002 24.8639 26.9167 24.5834 26.9167H16.0834C14.2389 26.9167 12.6805 25.7281 12.094 24.0833H20.3334C24.2391 24.0833 27.4167 20.9058 27.4167 17V8.5C29.7599 8.5 31.6667 10.4068 31.6667 12.75V30.9613ZM10.1334 17C9.50719 17 9.00002 16.4928 9.00002 15.8667V8.21667C9.00002 7.5905 9.50719 7.08333 10.1334 7.08333C10.7595 7.08333 11.2667 7.5905 11.2667 8.21667V15.8667C11.2667 16.4928 10.7595 17 10.1334 17ZM12.6834 8.21667C12.6834 7.5905 13.1905 7.08333 13.8167 7.08333H18.6334C19.2595 7.08333 19.7667 7.5905 19.7667 8.21667C19.7667 8.84283 19.2595 9.35 18.6334 9.35H17.3584V15.8681C17.3584 16.4943 16.8512 17.0014 16.225 17.0014C15.5989 17.0014 15.0917 16.4943 15.0917 15.8681V9.35H13.8167C13.1905 9.35 12.6834 8.84283 12.6834 8.21667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalianIcon);
export default __webpack_public_path__ + "static/media/italian-icon.ee94463d811cc1c261ed62c6c33e6e74.svg";
export { ForwardRef as ReactComponent };